<script setup lang="ts">
import TransactionalUpsell from './components/TransactionalUpsell.vue';
import AdminBoxes from './components/AdminBoxes.vue';
import AdminInventory from './components/AdminInventory.vue';
import ProviderPreparations from './components/ProviderPreparations.vue';

const travelerMatch = /^\/b\/([^/]+)(\/order(?:\/(?:confirmed|thanks))?)?$/.exec(
  globalThis.location.pathname,
);
let travelerToken: string | null = null;
try {
  travelerToken = travelerMatch ? decodeURIComponent(travelerMatch[1]) : null;
} catch {
  travelerToken = '';
}
const webCatalogueMatch = /^\/catalogue(?:\/(confirmed|thanks))?\/?$/.exec(
  globalThis.location.pathname,
);
const isAdmin = ['/', '/admin', '/admin/'].includes(globalThis.location.pathname);
const isAdminCatalog = ['/admin/catalog', '/admin/catalog/'].includes(
  globalThis.location.pathname,
);
const isAdminBoxes = ['/admin/boxes', '/admin/boxes/'].includes(globalThis.location.pathname);
const isAdminInventory = ['/admin/inventory', '/admin/inventory/'].includes(
  globalThis.location.pathname,
);
const isAdminManagement = [
  '/admin/providers-apartments',
  '/admin/providers-apartments/',
].includes(globalThis.location.pathname);
const isProvider =
  globalThis.location.pathname === '/provider' || globalThis.location.pathname === '/provider/';
const isTravelerOrder = travelerMatch?.[2]?.startsWith('/order') === true;
const isTravelerOrderConfirmed = travelerMatch?.[2] === '/order/confirmed';
const isTravelerOrderThanks = travelerMatch?.[2] === '/order/thanks';
</script>

<template>
  <TransactionalUpsell
    v-if="travelerToken !== null"
    v-bind="{
      publicToken: travelerToken,
      orderMode: isTravelerOrder,
      orderConfirmationMode: isTravelerOrderConfirmed,
      orderThanksMode: isTravelerOrderThanks,
    }"
  />
  <TransactionalUpsell
    v-else-if="webCatalogueMatch"
    public-token=""
    web-mode
    order-mode
    :order-confirmation-mode="webCatalogueMatch[1] === 'confirmed'"
    :order-thanks-mode="webCatalogueMatch[1] === 'thanks'"
  />
  <AdminInventory v-else-if="isAdminInventory" />
  <AdminBoxes
    v-else-if="isAdmin || isAdminCatalog || isAdminBoxes || isAdminManagement"
    :management-mode="isAdminManagement"
    :section="isAdminCatalog ? 'catalog' : isAdminBoxes ? 'boxes' : 'dashboard'"
  />
  <ProviderPreparations v-else-if="isProvider" />
  <main v-else class="missing-page" aria-labelledby="missing-page-title">
    <h1 id="missing-page-title">Page introuvable</h1>
    <p>Ce lien ne correspond à aucune page. Retrouvez les offres dans le catalogue.</p>
    <a class="missing-page-action" href="/catalogue">Accéder au catalogue</a>
  </main>
</template>

<style scoped>
.missing-page {
  min-height: 100svh;
  padding: 3rem 1.25rem;
  background: #ffffff;
  color: #172033;
  overflow-wrap: anywhere;
}
.missing-page h1,
.missing-page p {
  max-width: 36rem;
  margin: 0 auto 1.5rem;
}
.missing-page-action {
  display: block;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding: 0.9rem 1.25rem;
  border-radius: 0.75rem;
  background: #0b2341;
  color: #ffffff;
  font-weight: 700;
  text-align: center;
}
</style>
